import { GoogleLogo } from '../SVG/GoogleLogo';

import s from './GoogleSignInButton.module.css';

type Props = {
    label: string;
    onClick: () => void;
    disabled?: boolean;
};

export const GoogleSignInButton = ({ label, onClick, disabled = false }: Props): JSX.Element => (
    <button className={s.button} onClick={onClick} disabled={disabled} type="button">
        <div className={s.state} />
        <div className={s.contentWrapper}>
            <div className={s.icon}>
                <GoogleLogo size={20} />
            </div>
            <span className={s.contents}>{label}</span>
        </div>
    </button>
);
